/* eslint-disable*/
var checkCfa1Subscription = function checkCfa1Subscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  // console.log("selectedLevel", selectedLevel);
  // console.log("exam_data", exam_data);
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam)
  ) {
    if (selectedLevel === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            // Mock packages grant ONLY mock exams. This variant had no mock
            // guard at all, so a non-partner user holding just pkg 65/66 was
            // granted quiz access — the mirror of the partner-side bug.
            if (exam_data[i].levels[j].package_category === 'mock') continue;
            if (exam_data[i].levels[j].isActive) {
              flag = true;
              break;
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

var checkCfa1NotesSubscription = function checkCfa1NotesSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  // console.log("selectedLevel", selectedLevel);
  // console.log("exam_data", exam_data);

  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam)
  ) {
    if (selectedLevel === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 16
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        // console.log("worjjjjjjj");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            (exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 19 ||
              exam_data[i].levels[j].package_id === 39 ||
              exam_data[i].levels[j].package_id === 20)
          ) {
            // console.log("work");

            flag = true;
            break;
          }
        }
      }
    }
    return flag;
  }
};

var checkCfa1VideosSubscription = function checkCfa1VideosSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  // console.log("selectedLevel", selectedLevel);
  // console.log("exam_data", exam_data);
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam)
  ) {
    if (selectedLevel === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 16
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          // console.log('for-ELSE working');
          flag = true;
        }
        break;
      } else {
        // console.log("worjjjjjjj");
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

var checkCfa1PDFSubscription = function checkCfa1PDFSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  type
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam)
  ) {
    if (selectedLevel === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === 'question') {
                flag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === 'notes'
              ) {
                flag = true;
              }
              // break;/
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 16
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        // console.log("worjjjjjjj");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            (exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 19 ||
              exam_data[i].levels[j].package_id === 39 ||
              exam_data[i].levels[j].package_id === 20)
          ) {
            // console.log("work");

            flag = true;
            break;
          }
        }
      }
    }
    return flag;
  }
};

exports.checkCfa1Subscription = checkCfa1Subscription;
exports.checkCfa1NotesSubscription = checkCfa1NotesSubscription;
exports.checkCfa1VideosSubscription = checkCfa1VideosSubscription;
exports.checkCfa1PDFSubscription = checkCfa1PDFSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/Cfa1Subscription.js